<template>
    <div class="screen-container">
        <div class="heading-text-content mb-4 text-gray-900">
            <div class="text-gray-900 fw-bold fs-14 special-offer-text">SPECIAL OFFER ENDS IN {{ formattedTime }}</div>
            <h1 class="ff-montserrat display-6 upgrade-title">Upgrade in the Next 2 Hours to Get 50% Off for 3 Months</h1>
            <p class="text-gray-600 fs-6 upgrade-description">If you're ready to make a difference
                in your business, we're ready to make it
                easier than ever to upgrade. Get the most out of Ashore today with 50% off
                any plan for the next three months.</p>
        </div>
        <div class="shadow-base bg-white rounded mb-4 text-gray-900">
            <div class="py-3 px-32 border-bottom">
                <h6 class="fw-bold mb-12">Why Upgrade?</h6>
                <ul class="d-flex flex-column gap-2 list-unstyled mb-0">
                    <li v-for="(item, index) in orderedFeatures" :key="index" class="d-flex align-items-center gap-2">
                        <div class="icon flex-shrink-0">
                            <img src="/img/check.svg" class="d-block" width="16" alt="Check">
                        </div>
                        <span class="fs-14 d-block">{{ item }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="d-inline-flex gap-2 flex-wrap">
            <button @click="handleUpgrade" class="btn btn-success fw-normal fs-6 button-final">Upgrade</button>
            <button @click="handleSkipUpgrade" class="btn btn-light fw-normal text-gray-700 skip-button">Skip</button>
        </div>
    </div>
</template>

<script>

import { ROUTES } from '../../utils/constants.js'
import { deleteCookie, isEligibleForFirstTimeOffer } from '../../utils/helpers.js'

export default {
    name: "Screen4",
    data() {
        return {
            order: [2, 1, 3, 5, 4],
            countdownSeconds: 7200,
        }
    },
    props: {
        featuresCanUnlock: {
            type: Array,
            required: true
        },
        currentStep: {
            type: Number,
            required: true
        }
    },
    async mounted() {
        await this.setOnboarding();
    },
    methods: {
        handleCheckListItemDelete(id) {
            const index = this.checkListItem.findIndex(item => item.id === id);
            if (index !== -1) {
                this.checkListItem.splice(index, 1);
            }
        },
        handleCheckListItem() {
            this.checkListItem.push({ id: this.checkListItem.length, message: "" });
        },
        setOnboarding: async function () {
            try {
                deleteCookie('isPromoBannerClosed');
                const currentUser = _.get(this, '$A.Auth', null);
                if (!currentUser) return;
                const response = await this.$A.UserService.UpdateUser(currentUser.id, { onboardingStep: this.currentStep, email: currentUser.email })

                if (response) {
                    this.$A.UpdateUserObjectAndBustCache(response);
                    const onboardedAtTimestamp = new Date(response.onboardedAt + 'Z').getTime();
                    const now = new Date();
                    const elapsedSeconds = Math.floor((now.getTime() - onboardedAtTimestamp) / 1000);
                    this.countdownSeconds = Math.max(7200 - elapsedSeconds, 0);

                    if (isEligibleForFirstTimeOffer(this.$A.Auth)) {
                        this.startCountdown();
                    }
                }
            } catch (error) {
                this.$A.AlertUser("Failed to update onboarding state. Please try again.", "error");
            }
        },
        handleUpgrade: function() {
            window.open(ROUTES.BILLING, '_self');
        },
        handleSkipUpgrade: function() {
            window.open(ROUTES.OVERVIEW , '_self');
        },
        startCountdown() {
            this.clearCountdown();
            this.timer = setInterval(() => {
                if (this.countdownSeconds > 0) {
                    this.countdownSeconds--;
                } else {
                    this.clearCountdown();
                }
            }, 1000);
        },
        clearCountdown() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
    },
    computed: {
        orderedFeatures() {
            return this.order.map(i => this.featuresCanUnlock[i - 1]);
        },
        formattedTime() {
            const hours = Math.floor(this.countdownSeconds / 3600);
            const minutes = Math.floor((this.countdownSeconds % 3600) / 60);
            const seconds = this.countdownSeconds % 60;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        }
    }
};
</script>

<style scoped>
.screen-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 6rem;
}

.heading-text-content {
    display: flex;
    flex-direction: column;
}

.button-final {
    color: #F9F9F9;
    font-size: 16px;
    font-weight: 400;
    padding: 13px 34.5px !important;
}

.special-offer-text {
    font-weight: 700;
}

.upgrade-title {
    font-weight: 800;
    font-size: 36px;
    margin-bottom: 16px;
}

.upgrade-description {
    font-size: 16px;
}

.skip-button {
    font-size: 16px;
    font-weight: 400;
    padding: 13px 51px;
    border: 1px solid #b5b5b8;
}
</style>
